<template>
  <div class="verify-email">
    <NhstValidateCodeAndChangePassword
      :description="description"
      @loggedInSuccess="onEmailVerified" />
  </div>
</template>

<script>

import { NhstValidateCodeAndChangePassword } from '@components/reset-password';
import { addTrackingEvent } from '@root/src/helpers/Tracking';
import { normalizeToLowerSnakeCase } from '@root/src/helpers/trackingLabels';

export default {
  name: 'nhst-verify-username',
  components: { NhstValidateCodeAndChangePassword },
  computed: {
    description() {
      return this.$t(
        'reset.password.validate.code.activate.subscription.description',
        { email: this.username }
      );
    }
  },
  mounted() {
    if (!this.isDN) {
      this.$authWebapp.pushAnalyticsTrackingEventForGlobalOrderflow();
    }
    this.trackStep('Validate Code And Change Password');
  },
  methods: {
    trackStep(verbalName) {
      const identifierValue = normalizeToLowerSnakeCase(verbalName);
      if (!identifierValue) return;
      addTrackingEvent({
        event: 'system_action',
        sub_producer_contract: { name: 'registration', version: '1' },
        attributes: {
          action: 'show',
          identifier_type: 'registration_step',
          identifier_value: identifierValue,
          registration_service: this.$authWebapp.getSource() || '',
          paywall_variation: this.$route.query.paywall_variation_type || '',
          flow_source_url: this.$authWebapp.getTarget('') || '',
        },
      });
    },
    onEmailVerified() {
      this.trackStep('Email Verified');
    }
  }
};
</script>
